import { AttributeList } from 'types/attributes';

export const getMaxedAttributes = (
    attributes: AttributeList,
    maxChar: number,
): AttributeList => {
    let accChar = 0;

    // The max value is determined by the number of characters counted against the maxChar
    let max = 0;

    if (!attributes) {
        return [];
    }

    for (const attribute of attributes) {
        accChar += attribute?.displayName?.length || 0;
        accChar += 5; // represent the padding and margin between tags

        if (accChar > maxChar) {
            break;
        } else {
            max++;
        }
    }

    return attributes.slice(0, max);
};
